(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__featuredCollectionForceProductLinksLoaded) return;
  window.__featuredCollectionForceProductLinksLoaded = true;

  var touchStartX = 0;
  var touchStartY = 0;
  var touchMoved = false;

  function isMobile() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function isInteractiveElement(target) {
    return target.closest(
      'button, input, select, textarea, label, form, summary, [role="button"], .button:not(a)'
    );
  }

  function getProductUrlFromEvent(event) {
    var target = event.target;

    if (!isMobile()) return null;

    var section = target.closest('[data-featured-collection-force-product-links]');
    if (!section) return null;

    if (isInteractiveElement(target)) return null;

    var productLink = target.closest('a[href*="/products/"]');

    if (!productLink) {
      var productCard = target.closest(
        '.card-product, .product-card, product-card, [data-product-card]'
      );

      if (productCard) {
        productLink = productCard.querySelector('a[href*="/products/"]');
      }
    }

    if (!productLink) return null;

    var href = productLink.getAttribute('href');

    if (!href || href === '#' || href.indexOf('javascript:') === 0) return null;

    var url = new URL(href, window.location.origin);

    if (url.origin !== window.location.origin) return null;
    if (url.pathname.indexOf('/products/') === -1) return null;

    return url.href;
  }

  function forceOpenProduct(event) {
    var url = getProductUrlFromEvent(event);

    if (!url) return false;

    event.preventDefault();
    event.stopPropagation();

    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }

    window.location.assign(url);

    return true;
  }

  document.addEventListener(
    'touchstart',
    function (event) {
      if (!isMobile()) return;

      var section = event.target.closest('[data-featured-collection-force-product-links]');
      if (!section) return;

      var touch = event.touches && event.touches[0];
      if (!touch) return;

      touchStartX = touch.clientX;
      touchStartY = touch.clientY;
      touchMoved = false;
    },
    true
  );

  document.addEventListener(
    'touchmove',
    function (event) {
      if (!isMobile()) return;

      var touch = event.touches && event.touches[0];
      if (!touch) return;

      var diffX = Math.abs(touch.clientX - touchStartX);
      var diffY = Math.abs(touch.clientY - touchStartY);

      if (diffX > 12 || diffY > 12) {
        touchMoved = true;
      }
    },
    true
  );

  document.addEventListener(
    'touchend',
    function (event) {
      if (touchMoved) return;

      forceOpenProduct(event);
    },
    {
      capture: true,
      passive: false
    }
  );

  document.addEventListener(
    'click',
    function (event) {
      forceOpenProduct(event);
    },
    true
  );
})();

  } catch(e) { console.error(e); }
})();
})();
